import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

type FileType = {
  error: string;
  filename: string;
  name: string;
  path: string;
  success: boolean;
};
type UploadAttachmentResponse = {
  files: FileType[];
};
export const uploadAttachment = async (
  bookingId: string,
  file: File
): Promise<UploadAttachmentResponse> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const formData = new FormData();
  formData.append("action", "uploadAttachments");
  formData.append("source", "admin");
  formData.append("booking_id", bookingId);
  formData.append("output", "json");
  formData.append("file", file);

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/messages`,
      {
        cache: "no-cache",
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      }
    );

    if (!response.ok) {
      apiFetchNotOkHandler(response, "Error uploading attachment");
      return { files: [] };
    }

    return (await response.json()).payload;
  } catch (error) {
    errorHandler(error, "Error uploading attachment");
    return { files: [] };
  }
};
